<template>
  <div class="card pemerintah">
    <h1>Daftar Jenis Surat</h1>
    <div class="list pemerintah">
      <ul>
        <li class="list__item" :class="{'active': surattitle === 'Surat Izin Opang'}" @click="suratSearchClickHandler('Surat Izin Opang')">Surat Izin Opang</li>
        <li class="list__item" :class="{'active': surattitle === 'Surat Kartu Pekerja'}" @click="suratSearchClickHandler('Surat Kartu Pekerja')">Surat Kartu Pekerja</li>
        <li class="list__item" :class="{'active': surattitle === 'Surat Pergantian Ktp'}" @click="suratSearchClickHandler('Surat Pergantian Ktp')">Surat Pergantian KTP</li>
        <li class="list__item" :class="{'active': surattitle === 'Surat Pencabutan Warga Negara'}" @click="suratSearchClickHandler('Surat Pencabutan Warga Negara')">Surat Pencabutan Warga Negara</li>
        <li class="list__item" :class="{'active': surattitle === 'Surat Keterangan Kematian'}" @click="suratSearchClickHandler('Surat Keterangan Kematian')">Surat Keterangan Kematian</li>
        <li class="list__item" :class="{'active': surattitle === 'Surat Izin Kegiatan'}" @click="suratSearchClickHandler('Surat Izin Kegiatan')">Surat Izin Kegiatan</li>
      </ul>
    </div>
  </div>
  <div class="card card__middle pemerintah">
    <h1>List Surat</h1>
    <div class="list pemerintah">
      <ul>
        <li class="list__item" v-for="(surat, i) in suratList" :key="i" @click="showSuratInfo(surat)">
          <p>{{ surat.firstname }} {{ surat.lastname }}</p>
          <p class="small">Nomor Surat: {{ surat.nomorSurat }}</p>
        </li>
      </ul>
    </div>
  </div>
  <div class="card" :class="{hide: !suratInfo, pemerintah: suratInfo}">
    <img :src="individualSurat.imageUrl" :alt="individualSurat.nomorSurat" />
  </div>
</template>
<script>
  import SuratSearchController from '@/components/Controller/SuratSearchController.vue';
  export default {
    extends: SuratSearchController,
    data() {
      return {
        surattitle: 'Surat Izin Opang',
        suratList: [],
        suratInfo: false,
        individualSurat: {},
      }
    },
    mounted() {
      this.getAllSurat(this.surattitle)
        .then(data => {
          this.suratList = data.result
        })
    },
    methods: {
      suratSearchClickHandler(surattitle) {
        this.surattitle = surattitle;
        this.getAllSurat(this.surattitle)
          .then(data => {
            this.suratList = data.result
          })
      },
      showSuratInfo(surat) {
        this.suratInfo = true;
        this.individualSurat = surat;
      }
    }
  }
</script>
<style scoped>
  h1 {
    font-size: 25px;
    padding: 20px 20px 0;
  }
  .list.pemerintah li.active {
    background: rgb(1, 87, 1)
  }

  .card:first-child {
    width: 25%
  }
  .card:nth-child(2) {
    width: 30%
  }
  .card:last-child {
    width: 45%
  }
  img {
    display: block;
    margin: 20px auto;
  }
</style>